import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=20d7a34a"
import script from "./BreadCrumbs.vue?vue&type=script&lang=ts"
export * from "./BreadCrumbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports